module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SYFt2J/html/docimages/cover_ader.jpg?1684274498447",
      "alt": "This image is the cover for the book The Cross and the Beatitudes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Cross and the Beatitudes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Fulton J. Sheen was remarkable in his ability to uncover many layers of meaning in the life and words of Jesus of Nazareth. The Seven Beatitudes and The Seven Words from the Cross -- both were delivered from a mountain, but the connection runs deeper than that. As Bishop Sheen points out, Our Lord began His Public Life on the Mount of the Beatitudes and closed it on the Mount of Calvary. On the first He uttered the words central to His message; on the second He spoke to the deed central to His mission. Two avenues were thereby opened: one for spreading the Good News throughout the world, the other for reconciling all men to God through Christ. Fulton Sheen's profound meditations will slake the spiritual thirst of all who desire a fuller understanding of the Gospels and seek to draw closer to Christ.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fulton J. Sheen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Fulton Sheen was unparalleled in his ability to combine theology, devotion, and the profoundest meditation on the central events of the Christian narrative. Displayed here in full are the literary and rhetorical gifts of one of the greatest preachers of the twentieth century.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Angelico Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0